module.exports = __webpack_public_path__ + "media/images/countrysquared/pf-3b5503901ef977ecab83fdd632b9617d.svg";